export default __webpack_public_path__ + "static/media/viewReportIcon.ee175a1d.svg";